module.exports = __webpack_public_path__ + "Wireframes4.png?f373699202408c74b5ebac77d46d51a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes4.png
// module id = 118
// module chunks = 0